import { useState } from 'react';

/**
 * Hook to manage modal state for RaiseQuery page
 * @returns {Object} Modal state and handlers
 */
export const useRaiseQueryPageModals = () => {
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [escalateDialogOpen, setEscalateDialogOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [escalateTarget, setEscalateTarget] = useState(null);

  const handleOpenViewModal = (query) => {
    setSelectedQuery(query);
    setViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenEditModal = (query) => {
    setSelectedQuery(query);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenDeleteDialog = (query) => {
    setSelectedQuery(query);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSelectedQuery(null);
  };

  const handleOpenEscalateDialog = (query) => {
    setEscalateTarget(query);
    setEscalateDialogOpen(true);
  };

  const handleCloseEscalateDialog = () => {
    setEscalateDialogOpen(false);
    setEscalateTarget(null);
  };

  const handleOpenCloseDialog = (query) => {
    setSelectedQuery(query);
    setCloseDialogOpen(true);
  };

  const handleCloseCloseDialog = () => {
    setCloseDialogOpen(false);
    setSelectedQuery(null);
  };

  return {
    viewModalOpen,
    editModalOpen,
    deleteDialogOpen,
    closeDialogOpen,
    escalateDialogOpen,
    selectedQuery,
    escalateTarget,
    setViewModalOpen,
    setEditModalOpen,
    setDeleteDialogOpen,
    setCloseDialogOpen,
    setEscalateDialogOpen,
    setSelectedQuery,
    setEscalateTarget,
    handleOpenViewModal,
    handleCloseViewModal,
    handleOpenEditModal,
    handleCloseEditModal,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleOpenCloseDialog,
    handleCloseCloseDialog,
    handleOpenEscalateDialog,
    handleCloseEscalateDialog,
  };
};
